interface TemplateStep {
  id: string;
  stepType: string;
}

/**
 * The analysis step that corresponds to each template step, keyed by the template step's id.
 *
 * Applying a template copies its steps into the analysis in order, so a template step corresponds to the
 * analysis step of the same type at the same position among steps of that type. Steps of a type are only
 * matched when the analysis still has as many of them as the template: once steps of that type have been
 * added to or deleted from the analysis, their positions no longer identify which template step each came
 * from.
 */
export default function getCorrespondingAnalysisSteps<AnalysisStep extends {stepType: string}>(
  templateSteps: ReadonlyArray<TemplateStep>,
  analysisSteps: ReadonlyArray<AnalysisStep>
): Map<string, AnalysisStep> {
  const correspondingSteps = new Map<string, AnalysisStep>();
  for (const stepType of new Set(templateSteps.map((step) => step.stepType))) {
    const templateStepsOfType = templateSteps.filter((step) => step.stepType === stepType);
    const analysisStepsOfType = analysisSteps.filter((step) => step.stepType === stepType);
    if (templateStepsOfType.length !== analysisStepsOfType.length) {
      continue;
    }
    templateStepsOfType.forEach((templateStep, index) => {
      correspondingSteps.set(templateStep.id, analysisStepsOfType[index]);
    });
  }
  return correspondingSteps;
}
